import React from "react";
import { styled } from "@linaria/react";
import { color } from "@ui";
import t from "../../../../i18n";
import { HIDE_ON_EXPORT } from "@ui/lib/downloadPage";
import Badge from "@ui/Badge";
import { ToolsFill } from "@ui/IconV2/react";
import { useTranslations } from "../../../../api/useTranslations";
import type { Reparability } from "../../../../api/Reparability";
import { REPARABILITY_COLOR } from "../../../../api/Reparability";

const ToolWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Tool = styled(ToolsFill)`
  height: 14px;
  width: 14px;
  margin-right: 8px;
`;

interface P extends React.HTMLAttributes<HTMLDivElement> {
  reparability: Reparability;
}

const ReparabilityTag = ({ reparability }: P) => {
  const translations = useTranslations();
  return (
    <Badge
      backgroundColor={REPARABILITY_COLOR[reparability]}
      color={color.hydrogen}
      icon={
        <ToolWrapper className={HIDE_ON_EXPORT}>
          <Tool />
        </ToolWrapper>
      }
    >
      {t("reparability", reparability, translations)}
    </Badge>
  );
};
export default ReparabilityTag;
